const isChromium: boolean = !!(typeof window === 'object' && (<any>window).chrome);
const devToolDetectionEnabled = isChromium;
let detectorElement: HTMLElement | undefined;
let isDevToolEverOpened = false;

/**
 * ATTENTION: READ THE BELOW LIMITATIONS BEFORE USE.
 * 1. This only works for Chromium browsers.
 * 2. Right now we only detect dev tool is ever opened in the window level, which means even dev tool never
 *    opened through a component's entire life, it may also return true if the dev tool is opened and close
 *    before the component's instantiation.
 *
 * We are not able to provide "isDevToolCurrentlyOpened" due to we can only get "dev tool open" notification,
 * there is no "dev tool closed" notification.
 *
 * We are not doing the detection on the component level because:
 * 1. We need to start detection before component is instantiated, so we will need to create a new tracking id
 *    and passing it all over the places necessary throughout the component lifetime. We would like to keep it
 *    as simple as possible for now unless necessary.
 * 2. Every time we start the detection, it will write a console log, a document may have lots of document, doing
 *    detection per component will lead to many console logs.
 *
 * Given the above limitations, this could be used as a "overkilled" method to filter out all the potential
 * dev tool opened sessions, so that we can do data analysis on the "smaller" but "cleaner" dataset.
 */
export function isDevToolEverOpenedInCurrentWindow(): boolean {
  return isDevToolEverOpened;
}

function ensureDetectorElement(): void {
  if (!detectorElement) {
    detectorElement = document.createElement('DevToolDetector');
    Object.defineProperty(detectorElement, 'id', {
      get() {
        isDevToolEverOpened = true;
      }
    });
  }
}

function startDevToolDetection(): void {
  ensureDetectorElement();
  console.dir(detectorElement);
}

if (devToolDetectionEnabled) {
  startDevToolDetection();
}
